module.exports = __webpack_public_path__ + "static/media/VIP_Room@3x.e758c61d.png";